export const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
      <h1 className="text-[120px] sm:text-[180px] font-black text-[#ff6b6b] italic leading-none mb-8">
        404.
      </h1>
      <p className="text-foreground text-xl sm:text-2xl font-bold mb-6">
        Vaja! No s'ha trobat la pàgina.
      </p>
      <p className="text-foreground text-xl sm:text-2xl font-bold">
        Torna{" "}
        <a 
          href="https://cotx.es" 
          className="underline hover:text-[#ff6b6b] transition-colors"
        >
          a l'inici
        </a>
        . 🚗
      </p>
    </div>
  );
};
